import Vue from 'vue'

export default Vue.extend({
  template: `
      <span>
        <b-button
          :type="this.params.btnType"
          :title="this.params.btnTitle"
          :icon-left="this.params.btnIcon"
          @click="btnClickedHandler()"
          :style="this.params.btnStyle"
          :label="this.params.btnLabel"
          :size="this.params.btnSize"
        />
      </span>
    `,
  methods: {
    btnClickedHandler () {
      this.params.clicked(this.params)
    }
  }
})
